export default __webpack_public_path__ + "static/media/snapshot.1e19665c.svg";